import React from 'react';
import { useUserHasRole } from '../hooks/useUserHasRole';
import { EditBusiness as AdminEditBusiness } from './admin/EditBusiness';
import { UserEditBusiness } from './UserEditBusiness';

export const EditBusiness: React.FC<{}> = () => {
	return useUserHasRole('admin') ? <AdminEditBusiness /> : <UserEditBusiness />;
};
